import React, { useState, useEffect } from 'react';
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  IconButton,
  CircularProgress,
  CardMedia,
  Chip,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import api from '../services/api';

const PortalWishlist = () => {
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWishlist();
  }, []);

  const fetchWishlist = async () => {
    try {
      const token = localStorage.getItem('portal_access_token');
      const response = await api.get('/portal/wishlist', {
        headers: { Authorization: `Bearer ${token}` }
      });

      setWishlist(response.data.wishlist || []);
    } catch (error) {
      console.error('Failed to fetch wishlist:', error);
    } finally {
      setLoading(false);
    }
  };

  const removeFromWishlist = async (itemId) => {
    try {
      const token = localStorage.getItem('portal_access_token');
      await api.delete(`/portal/wishlist/${itemId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setWishlist(wishlist.filter((item) => item.item_id !== itemId));
    } catch (error) {
      console.error('Failed to remove from wishlist:', error);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        My Wishlist
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Items you've saved for later
      </Typography>

      {wishlist.length > 0 ? (
        <Grid container spacing={2}>
          {wishlist.map((wishlistItem) => (
            <Grid item xs={12} sm={6} md={4} key={wishlistItem.id}>
              <Card>
                {wishlistItem.item?.photos?.[0] && (
                  <CardMedia
                    component="img"
                    height="200"
                    image={`${process.env.REACT_APP_API_URL || 'https://api.paceestate.com'}${wishlistItem.item.photos[0].file_path}`}
                    alt={wishlistItem.item.name}
                  />
                )}
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6">{wishlistItem.item?.name}</Typography>
                      <Typography variant="h5" color="primary" sx={{ mt: 1 }}>
                        ${wishlistItem.item?.price}
                      </Typography>
                      <Chip
                        label={wishlistItem.item?.status}
                        color={wishlistItem.item?.status === 'available' ? 'success' : 'default'}
                        size="small"
                        sx={{ mt: 1 }}
                      />
                    </Box>
                    <IconButton
                      onClick={() => removeFromWishlist(wishlistItem.item_id)}
                      color="error"
                    >
                      <Delete />
                    </IconButton>
                  </Box>

                  {wishlistItem.notes && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                      Notes: {wishlistItem.notes}
                    </Typography>
                  )}

                  <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                    Added {new Date(wishlistItem.created_at).toLocaleDateString()}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography color="text.secondary">
          Your wishlist is empty. Browse sales to add items!
        </Typography>
      )}
    </Box>
  );
};

export default PortalWishlist;
